"use strict";'use strict';

var chunkX4J3JQ4I_js = require('./chunk-X4J3JQ4I.js');
require('./chunk-RQDAWUCF.js');



module.exports = chunkX4J3JQ4I_js.Right_default;
